import axios from 'axios'

const BASEURL = process.env.VUE_APP_APIA_URL

const targets = {
  namespaced: true,
  state: {
    targets: [],
    loaded: false,
  },
  mutations: {
    setTargets(state, data) {
      state.targets = data
    },
    setLoaded(state, data) {
      state.loaded = data
    },
  },
  actions: {
    loadTargets({ rootState, dispatch, commit }) {
      let params = {}
      if (rootState.request.authorized.access) {
        params.headers = {
          Authorization: `Bearer ${rootState.request.authorized.access}`,
        }
      }

      commit('setTargets', [])
      commit('setLoaded', false)
      return new Promise(() => {
        axios
          .get(
            `${BASEURL}targets/v1/t/${rootState.market.platform}:${rootState.market.ticker}`,
            params
          )
          .then((res) => {
            commit('setTargets', res.data.targets)
            commit('setLoaded', true)
          })
          .catch((err) => {
            if (
              !(
                err.response.data.code === 404 &&
                err.response.data.type === 'TARGET_NOT_FOUND'
              )
            ) {
              dispatch('layout/showMessage', {
                title: 'Error',
                message: `Getting targets ${err}`,
                type: 'error',
              })
            }
          })
      })
    },
  },
  getters: {
    getTargets(state, getters, rootState) {
      let targets = state.targets
        ? state.targets.map((target) => {
            let targetsWithPrice = Object.assign({}, target)
            targetsWithPrice.openPrice = rootState.market.currentPrice
            return targetsWithPrice
          })
        : false
      return targets
    },
  },
}

export default targets
